import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const LeftArrowIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={7}
      height={10}
      viewBox="0 0 7 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.03.47a.75.75 0 010 1.06L2.56 5l3.47 3.47a.75.75 0 01-1.06 1.06l-4-4a.75.75 0 010-1.06l4-4a.75.75 0 011.06 0z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default LeftArrowIcon;
